import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../../lib/apolloClient';

/**
 * Wrapper component that provides Apollo Client context to child components
 * This is needed for containers that use Apollo hooks (useQuery, useMutation, etc.)
 */
const ApolloWrapper = ({ children }) => {
  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  );
};

export default ApolloWrapper;


